import { z } from 'zod';
import { isFutureDate } from 'shared/utils/date-utils';
import { DateNotInFutureRule } from '../../../dynamic-form.types';

export const applyDateNotInFutureSchema = (schema: z.ZodTypeAny, rule: DateNotInFutureRule) => {
  const errorMessage = rule.copy;

  return schema.refine(
    (data: Record<string, unknown>) => {
      const value = data[rule.field];

      if (!value) {
        return true;
      }

      return !isFutureDate(value);
    },
    {
      message: errorMessage,
      path: [rule.field],
    }
  );
};
